import { render, staticRenderFns } from "./TemplateManagement.vue?vue&type=template&id=6a0eb002&scoped=true"
import script from "./TemplateManagement.vue?vue&type=script&lang=js"
export * from "./TemplateManagement.vue?vue&type=script&lang=js"
import style0 from "./TemplateManagement.vue?vue&type=style&index=0&id=6a0eb002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0eb002",
  null
  
)

export default component.exports